module.exports = __webpack_public_path__ + "media/public/images/icon-remove-favorite-4cb89e05c3346829924814262af93b5e.svg";